import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatSelectModule } from "@angular/material/select";
import { Store } from "@ngrx/store";
import { map, Observable } from 'rxjs';
import { ButtonComponent } from "daisy-design-system-front";
import { NavigationService } from "../../../services/navigation.service";
import { MappedExportTemplate } from "../../../../models/export-templates/export-template.models";
import { selectExportTemplatesForm, ExportTemplatesActions } from "../../../../store";
import {DropdownComponent} from '@gnv-shared/components';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: "app-dialog-templates-choice",
  templateUrl: "./dialog-templates-choice.component.html",
  styleUrls: ["./dialog-templates-choice.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatSelectModule,
    FormsModule,
    ButtonComponent,
    DropdownComponent,
    TranslatePipe
  ],
})
export class DialogTemplatesChoiceComponent implements OnInit {
  public formGroup!: FormGroup;
  public valueFormControl = new FormControl<MappedExportTemplate | undefined>(undefined, {validators: [Validators.required]});
  public tableView$: Observable<any>

  constructor(
    public dialogRef: MatDialogRef<DialogTemplatesChoiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly store: Store,
    private readonly navigationService: NavigationService
  ) {
    this.formGroup = new FormGroup({
      selectedCity: new FormControl<any | null>(null),
    });

    this.tableView$ = this.store.select(selectExportTemplatesForm).pipe(
      map(response => response.tableSummary?.rows.map(item => ({label: item["name"], value: item})))
    );
  }

  ngOnInit(): void {
    const searchFilter = {
      limit: 100,
      offset: 0,
    };

      this.store.dispatch(
          ExportTemplatesActions.search({
            filter: searchFilter,
            currentPage: 1,
          })
        );

  }

  validate() {
    if (this.valueFormControl.valid) {
      this.dialogRef.close({ selectedModel: this.valueFormControl.value});
    }
  }

  createNewtTemplate(accept = false) {
    // TODO


    this.dialogRef.close({ createNewTemplate: true });
  }

  cancel() {
    this.navigationService.gotoExportRequestPage();
  }
}
